import React from 'react';
import _ from 'underscore';
import { buildReportTypeMapping } from '@bingads-webui-campaign/reports-v4-report-type-mapping';
import { RecentReportTitle } from './recent-reports/recent-report-title';
import { RecentReportMenuItem } from './recent-reports/recent-report-menu-item';

const maxRecentReportCount = 5;

export function generateRecentReportMenuItems({
  recentReports,
  siteMap,
  classes,
  navigate,
  serverContext,
  onClickRecentReportItem = _.noop,
}) {
  if (recentReports['@odata.count'] && recentReports.value.length) {
    const headerId = 'RecentReportsTitle';

    const titleItem = {
      key: 'recent-reports-title',
      onRender: () => <RecentReportTitle id={headerId} />,
    };

    const reportTypeMapping = buildReportTypeMapping(siteMap);

    const otherItems = recentReports.value
      .slice(0, maxRecentReportCount)
      .map(report => ({
        key: `recent-reports-${report.Id}-${report.ReportType}`,
        onRender: (menuItem, dismissMenu) => (
          <RecentReportMenuItem
            report={report}
            closeDropdown={() => dismissMenu(null, true)}
            reportTypeMapping={reportTypeMapping}
            classes={classes}
            navigate={navigate}
            onClick={() => onClickRecentReportItem({ menuItem, report })}
            serverContext={serverContext}
            headerId={headerId}
          />),
      }));

    return [
      titleItem,
      ...otherItems,
    ];
  }

  return [];
}
